import React from "react";

import useDecodedParams from "Hooks/useDecodedParams";

import Backups from "./containers/Backups";

type EnvironmentURLParams = {
  environmentId: string;
  projectId: string;
  organizationId: string;
};

type Props = {
  Component: React.ComponentType<EnvironmentURLParams>;
};

const Page = ({ Component }: Props) => {
  const { environmentId, projectId, organizationId } =
    useDecodedParams<EnvironmentURLParams>();

  return (
    <Backups
      projectId={projectId}
      organizationId={organizationId}
      environmentId={environmentId}
    >
      <Component
        projectId={projectId}
        organizationId={organizationId}
        environmentId={environmentId}
      />
    </Backups>
  );
};

export default Page;
